import * as M from "@radix-ui/react-dropdown-menu";
import { MoreHorizontal } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "./cn";

export interface MenuAction {
  label: string;
  onSelect(): void;
  icon?: ReactNode;
  danger?: boolean;
  disabled?: boolean;
  hidden?: boolean;
}

/** Row-level action menu. Hidden actions are omitted; the server still enforces every permission. */
export function ActionMenu({ actions, label = "Actions", trigger }: { actions: MenuAction[]; label?: string; trigger?: ReactNode }) {
  const visible = actions.filter((a) => !a.hidden);
  if (!visible.length) return null;
  return (
    <M.Root>
      <M.Trigger asChild>
        {trigger ?? (
          <button
            type="button"
            aria-label={label}
            onClick={(e) => e.stopPropagation()}
            className="inline-flex h-8 w-8 items-center justify-center rounded-lg text-muted hover:bg-surface-3 hover:text-fg"
          >
            <MoreHorizontal size={16} />
          </button>
        )}
      </M.Trigger>
      <M.Portal>
        <M.Content align="end" sideOffset={4} className="z-50 min-w-48 rounded-xl border border-line bg-surface p-1.5 shadow-lg" onClick={(e) => e.stopPropagation()}>
          {visible.map((a) => (
            <M.Item
              key={a.label}
              disabled={a.disabled}
              onSelect={a.onSelect}
              className={cn(
                "flex cursor-pointer items-center gap-2 rounded-lg px-2.5 py-2 text-[13px] outline-none select-none data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50 data-[highlighted]:bg-surface-2",
                a.danger ? "text-danger" : "text-fg",
              )}
            >
              {a.icon}
              {a.label}
            </M.Item>
          ))}
        </M.Content>
      </M.Portal>
    </M.Root>
  );
}

export { M as DropdownPrimitive };
